import { DollarSign, MessageCircle } from "react-feather";

import ShippingIcon from "../../Components/Common/svg/Shippingicon";
import ActivitesIcon from "../../Components/Common/svg/activitiesicon";
import DashIcon from "../../Components/Common/svg/dashicon";
import MarketingIcon from "../../Components/Common/svg/marktingicon";
import PosIcon from "../../Components/Common/svg/posicon";
import ProductsSection from "../../Components/Common/svg/productsicon";
import ReportsIcon from "../../Components/Common/svg/reportsicon";
import shoppingIcon from "../../Components/Common/svg/shoppingicon";
import StoreIconSide from "../../Components/Common/svg/storeiconside";
import SystemSettingsIcon from "../../Components/Common/svg/systemSettings";
import TechnicalSupportIcon from "../../Components/Common/svg/technicalsupport";
import UsersIcon from "../../Components/Common/svg/usersIcon";
import RewardsIcon from "../../Components/Common/svg/rewardsicon";

import UsersIcons from "../../Components/Common/svg/settingsicons/users";
import CategoriesIcon from "../../Components/Common/svg/settingsicons/categories";
import LocationIcon from "../../Components/Common/svg/settingsicons/locations";
import VechilesIcon from "../../Components/Common/svg/settingsicons/vechiles";
import ReviewsIcon from "../../Components/Common/svg/settingsicons/reviews";
import LoyaltyIcon from "../../Components/Common/svg/settingsicons/loyality";
import TermsIcon from "../../Components/Common/svg/settingsicons/terms";
import NotificationsIcon from "../../Components/Common/svg/settingsicons/notifications";
import LanguageIcon from "../../Components/Common/svg/settingsicons/language";
import { FaHourglassStart } from "react-icons/fa";
import ClockIcon from "../../Components/Common/svg/reports/clockicon";

export const MENUITEMS = [
  {
    menutitle: "",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "لوحة التحكم",
        icon: DashIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/home`,
      },
      {
        title: "الطلبات",
        icon: shoppingIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/orders`,
        permission: "manage_orders",
      },
      {
        title: "المتاجر",
        icon: StoreIconSide,
        type: "sub",
        active: false,
        permission: ["view_store", "view_pos_terminal", "view_vendor"],
        children: [
          {
            title: "أصحاب المتاجر والموظفين",
            type: "link",
            path: `${process.env.PUBLIC_URL}/vendors`,
            permission: "view_vendor",
          },
          {
            title: "المتاجر",
            type: "link",
            path: `${process.env.PUBLIC_URL}/stores`,
            permission: "view_store",
          },
          // {
          //   title: "نقاط البيع",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/pos`,
          // permission:"view_pos_terminal",

          // },
        ],
      },
      {
        title: "المنتجات",
        icon: ProductsSection,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/products`,
        permission: "manage_products",
      },
      {
        title: "العملاء",
        icon: UsersIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/users`,
        permission: "view_user",
      },
      {
        title: "التوصيل",
        icon: ShippingIcon,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/shipping`,
                  permission: [
          "view_delivery_company",
          "view_couier",
          "view_shipping_price",
        ],
        children: [
          {
            title: "شركات الشحن",
            type: "link",
            path: `${process.env.PUBLIC_URL}/shipping-companies`,
                    permission:
            "view_delivery_company",
          },
          {
            title: "السائقين",
            type: "link",
            path: `${process.env.PUBLIC_URL}/drivers`,
            permission: "view_couier",
          },
          {
            title: "تسعير المناطق",
            type: "link",
            path: `${process.env.PUBLIC_URL}/area-pricing`,
            permission: "view_shipping_price",
          },
        ],
      },
      // {
      //   title: "نقاط البيع",
      //   icon: PosIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/pos`,
      //   permission: "view_pos_terminal",
      // },
      // {
      //   title: "إدارة الماليات",
      //   icon: DollarSign,
      //   type: "sub",
      //   active: false,
      //   // path: `${process.env.PUBLIC_URL}/financial-management`,
      //   permission: [
      //     "view_payment_method",
      //     "view_transaction",
      //     "update_store",
      //     "view_withdrawal",
      //   ],
      //   children: [
      //     {
      //       title: "إعدادات العمولة",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/commission-settings`,
      //   permission: [
      //     "view_payment_method",
      //     "view_transaction",
      //     "update_store",
      //     "view_withdrawal",
      //   ],
      //     },
      //     {
      //       title: "طلبات الدفع",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/payment-requests`,
      //   permission: [
      //     "view_payment_method",
      //     "view_transaction",
      //     "update_store",
      //     "view_withdrawal",
      //   ],
      //     },
      //     {
      //       title: "سجل المدفوعات",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/payment-record`,
      //   permission: [
      //     "view_payment_method",
      //     "view_transaction",
      //     "update_store",
      //     "view_withdrawal",
      //   ],
      //     },
      //     {
      //       title: "طرق الدفع",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/payment-methods`,
      //   permission: [
      //     "view_payment_method",
      //     "view_transaction",
      //     "update_store",
      //     "view_withdrawal",
      //   ],
      //     },
      //   ],
      // },
      {
        title: "التقارير والتحليلات ",
        icon: ReportsIcon,
        type: "sub",
        active: false,
        // path: `${process.env.PUBLIC_URL}/reports-analytics`,
        permission: "view_reports",
        children: [
          {
            title: "تقرير المبيعات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/sales-report`,
            permission: "view_reports",
          },
          {
            title: "تقرير الطلبات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/orders-report`,
            permission: "view_reports",
          },
          {
            title: "تقرير العملاء",
            type: "link",
            path: `${process.env.PUBLIC_URL}/customer-report`,
            permission: "view_reports",
          },
          // {
          //   title: "تقرير المتاجر",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/stores-report`,
          // permission: "view_reports",

          // },
          // {
          //   title: "تقرير التوصيل",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/delivery-report`,
          // permission: "view_reports",

          // },
        ],
      },

      {
        title: "التسويق  ",
        icon: MarketingIcon,
        type: "sub",
        active: false,
        // path: `${process.env.PUBLIC_URL}/marking`,
        permission: ["view_coupon", "view_banner", "view_offer"],
        children: [
          {
            title: "كوبونات الخصم",
            type: "link",
            path: `${process.env.PUBLIC_URL}/coupons`,
            permission: "view_coupon",
          },
          {
            title: "البانرات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/banners`,
            permission: "view_banner",
          },
          {
            title: "العروض الخاصة",
            type: "link",
            path: `${process.env.PUBLIC_URL}/special-offers`,
            permission: "view_offer",
          },
          {
            title: "العروض السريعة",
            type: "link",
            path: `${process.env.PUBLIC_URL}/quick-offers`,
            permission: "view_offer",
          },
          {
            title: "العروض الترويجية",
            type: "link",
            path: `${process.env.PUBLIC_URL}/promotions`,
            permission: "view_promotion",
          },
          {
            title: "السلايدرات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/sliders`,
            permission: "view_slider",
          },
        ],
      },
      // {
      //   title: "الأرباح",
      //   icon: RewardsIcon,
      //   type: "sub",
      //   active: false,
      //   // path: `${process.env.PUBLIC_URL}/rewards`,
      //   permission: "view_reward",
      //   children: [
      //     {
      //       title: "إجمالي النقاط",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/points`,
      //   permission: "view_reward",

      //     },
      //     {
      //       title: "سحب قيمة الطلبات",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/order-amount`,
      //   permission: "view_reward",

      //     },
      //     {
      //       title: "تبديل النقاط",
      //       type: "link",
      //       path: `${process.env.PUBLIC_URL}/exchange-points`,
      //   permission: "view_reward",

      //     },
      //   ],
      // },

      {
        title: "الدعم  ",
        icon: TechnicalSupportIcon,
        type: "sub",
        active: false,
        // path: `${process.env.PUBLIC_URL}/technical-support`,
        permission: "handle_customer_service",
        children: [
          {
            title: "دعم",
            type: "link",
            path: `${process.env.PUBLIC_URL}/support`,
            permission: "handle_customer_service",
          },
          {
            title: "التقييمات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/reviews`,
            permission: "handle_customer_service",
          },
        ],
      },

      // {
      //   title: "سجلات النشاط  ",
      //   icon: ActivitesIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/activity-logs`,
      // },
      // {
      //   title: " إعدادات النظام  ",
      //   icon: SystemSettingsIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/system-settings`,
      //   permission: "view_setting",
      // },
      {
        // title: "المشرفين والأدوار",
        title: "المشرفين",
        icon: UsersIcons,
        type: "link",
        path: `${process.env.PUBLIC_URL}/admins`,
        active: false,
        permission: ["view_role", "view_admin"],
        children: [
          // {
          //   title: "الأدوار و الصلاحيات",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/roles`,
          // permission: "view_role",
          // },
          // {
          //   title: "المشرفين",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/admins`,
          // permission: "view_admin",
          // },
        ],
      },
      {
        title: "الفئات",
        icon: CategoriesIcon,
        type: "sub",
        active: false,
        permission: ["view_category", "view_section"],
        children: [
          {
            title: " الفئات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/categories`,
            permission: "view_category",
          },
          {
            title: "الأقسام",
            type: "link",
            path: `${process.env.PUBLIC_URL}/sections`,
            permission: "view_section",
          },
        ],
      },
      {
        title: "إعدادات الأماكن",
        icon: LocationIcon,
        type: "sub",
        active: false,
        permission: [
          "view_country",
          "view_city",
          "view_governorate",
          "view_zone",
        ],
        children: [
          // {
          //   title: " الدول",
          //   type: "link",
          //   path: `${process.env.PUBLIC_URL}/countries`,
          //   permission: "view_country",
          // },
          {
            title: "المحافظات",
            type: "link",
            path: `${process.env.PUBLIC_URL}/governorates`,
            permission: "view_governorate",
          },
          {
            title: " المدن",
            type: "link",
            path: `${process.env.PUBLIC_URL}/cities`,
            permission: "view_city",
          },
          {
            title: "المناطق",
            type: "link",
            path: `${process.env.PUBLIC_URL}/zones`,
            permission: "view_zone",
          },
        ],
      },
      {
        title: "أنواع المركبات",
        icon: VechilesIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/vehicles`,
        permission: "view_vehicle",
      },
      // {
      //   title: "التقييمات",
      //   icon: ReviewsIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/ratings`,
      //   permission: "view_rating_key",
      // },
      // {
      //   title: "نظام الولاء",
      //   icon: LoyaltyIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/loyalty`,
      //   permission: "view_loyalty_setting",
      // },
      {
        title: "السياسات وشروط الاستخدام",
        icon: TermsIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/terms`,
        permission: "view_admin_notification",
      },
      {
        title: "الرسائل والإشعارات",
        icon: NotificationsIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/notifications`,
        permission: "view_admin_notification",
      },
      // {
      //   title: "اللغة والإعدادات العامة",
      //   icon: LanguageIcon,
      //   type: "link",
      //   active: false,
      //   path: `${process.env.PUBLIC_URL}/language`,
      //   permission: "view_plan",
      // },
      {
        title: " ساعات العمل  ",
        icon: ClockIcon,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/working-hours`,
        permission: "edit_working_hours",
      },
      {
        title: "الشكاوي",
        icon: MessageCircle,
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/complaints`,
        permission: "view_contact_us",
      },
    ],
  },
];
